'use strict';

var toastr = require('toastr');
var _ = require('lodash');
function ConfigurationMarketClassFareService(restangular, configurationService, momentService, fileSaveService, $log) {
  var deleteService = restangular.service('domain').one('mcposAverageFareNew').one('bulk').one('fareDateRanges');
  var saveService = restangular.service('domain').one('mcposAverageFare').one('bulk').one('fareUpsert');
  var carrier = configurationService.getHostCarrier();
  function formatAsCsvRow(stringArayToFormat) {
    return stringArayToFormat.join(',') + '\r\n';
  }
  function createCsvHeader() {
    return formatAsCsvRow(['ORIGIN', 'DESTINATION', 'EFFECTIVE DATE', 'DISCONTINUE DATE', 'CLASS', 'FARE', 'SURCHARGE', 'TOTAL FARE']);
  }
  function createCsvRow(row) {
    return formatAsCsvRow([row.origin, row.destination, row.effectiveDate.toISOString(), row.discontinueDate.toISOString(), row["class"], row.fare, row.surcharge, row.totalFare]);
  }
  function exportMarketClassFares(gridId, data) {
    var fileData = createCsvHeader();
    for (var rowId = 0; rowId < data.length; rowId++) {
      fileData += createCsvRow(data[rowId]);
    }
    fileSaveService.createFile(fileData, 'text/csv', fileSaveService.createFileName(gridId, 'csv'));
  }
  function singleRowToJSON(entry) {
    var singleFare = {
      carrier: carrier,
      marketOrigin: entry.origin,
      marketDestination: entry.destination,
      eventTimeStamp: momentService.now(momentService.FIELD.EVENT_TIME_STAMP).toISOString(),
      classPOSAverageFares: {
        fareClass: entry["class"],
        pos: 'Default',
        ignoreForecastRegular: false,
        fareDateRanges: [{
          begin: entry.effectiveDate.toISOString(),
          end: entry.discontinueDate.toISOString(),
          fare: entry.fare
        }]
      }
    };
    return singleFare;
  }
  function createPreviousFareDateRangesValue(entry) {
    return {
      begin: entry._old.effectiveDate ? entry._old.effectiveDate.toISOString() : entry.effectiveDate.toISOString(),
      end: entry._old.discontinueDate ? entry._old.discontinueDate.toISOString() : entry.discontinueDate.toISOString(),
      fare: entry._old.fare || entry.fare
    };
  }
  function postColumnsSuccessHandler() {
    toastr.success('Successfully saved configuration changes.');
  }
  function postColumnsErrorHandler(response) {
    var errorMsg = 'Error when saving configuration changes. ' + response.statusText + ' (code ' + response.status + ')';
    $log.error('ConfigurationMarketClassFareService: postColumnsErrorHandler - ' + errorMsg);
    toastr.error(errorMsg);
  }
  function saveConfigurationMarketClassFare(selectedRows) {
    var faresToSave = {
      value: []
    };
    for (var i = 0; i < selectedRows.length; i++) {
      var singleFare = singleRowToJSON(selectedRows[i]);
      if (!selectedRows[i].isNewlyAdded) {
        singleFare.classPOSAverageFares.fareDateRanges[0].previous = createPreviousFareDateRangesValue(selectedRows[i]);
      }
      faresToSave.value.push(singleFare);
    }
    return saveService.customPUT(faresToSave).then(postColumnsSuccessHandler, postColumnsErrorHandler);
  }
  function removeMarketClassFares(selectedRows) {
    var faresToDelete = {
      value: []
    };
    for (var i = 0; i < selectedRows.length; i++) {
      var toRemove = _.extend({}, selectedRows[i], selectedRows[i]._old || {});
      var singleFare = singleRowToJSON(toRemove);
      faresToDelete.value.push(singleFare);
    }
    return deleteService.customOperation('remove', '', null, {
      'Content-Type': 'application/json'
    }, faresToDelete).then(postColumnsSuccessHandler, postColumnsErrorHandler);
  }
  return {
    saveConfigurationMarketClassFare: saveConfigurationMarketClassFare,
    removeMarketClassFares: removeMarketClassFares,
    exportMarketClassFares: exportMarketClassFares
  };
}
ConfigurationMarketClassFareService.$inject = ['Restangular', 'ConfigurationService', 'MomentService', 'FileSaveService', '$log'];
module.exports = ConfigurationMarketClassFareService;